module.exports = __webpack_public_path__ + "img/reputation.478a663c.svg";